export default {
  "freeSpinRecord.thead.freeSpinBonusId": "FreeSpinBonusId",
  "freeSpinRecord.thead.userno": "Userno",
  "freeSpinRecord.thead.email": "Email",
  "freeSpinRecord.thead.name": "Name",
  "freeSpinRecord.thead.firstName": "Firs tName",
  "freeSpinRecord.thead.lastName": "Last Name",
  "freeSpinRecord.thead.betAmount": "BetAmount",
  "freeSpinRecord.thead.spin": "Spin",
  "freeSpinRecord.thead.useSpin": "UseSpin",
  "freeSpinRecord.thead.bonusAmount": "BonusAmount",
  "freeSpinRecord.thead.chanceType": "ChanceType",
  "freeSpinRecord.thead.createTime": "CreateTime",
  "freeSpinRecord.thead.expireTime": "ExpireTime",
  "freeSpinRecord.title": "Free Spin Record",
};
